import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/spin/style";
import _Spin from "antd/lib/spin";
import "antd/lib/alert/style";
import _Alert from "antd/lib/alert"; /*@通用组件-请求返回*/
import ReactDOM from 'react-dom';
import React from 'react';
import { domain } from './commonConsts';
import Cookies from 'js-cookie';
var weburl = domain;
var ref = true;
var hasAlreadyAlert = false;
export default {
  convertObjToQueryString: function convertObjToQueryString(obj) {
    var paramStr = '';
    for (var name in obj) {
      paramStr += name + '=' + encodeURIComponent(obj[name]) + '&';
    }
    if (paramStr[paramStr.length - 1] === '&') return paramStr.slice(0, paramStr.length - 1);else return paramStr;
  },
  get: function get(originUrl, data) {
    var url = weburl + originUrl;
    var queryString = this.convertObjToQueryString(data);
    if (url.indexOf('?') !== -1) url = url + '&' + queryString;else url += '?' + queryString;
    return fetch(url, {
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'contentType': "application/x-www-form-urlencoded; charset=utf-8"
      }
    });
  },
  "delete": function _delete(originUrl, data) {
    var url = weburl + originUrl;
    var queryString = this.convertObjToQueryString(data);
    if (url.indexOf('?') !== -1) url = url + '&' + queryString;else url += '?' + queryString;
    return fetch(url, {
      method: 'delete',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'contentType': "application/x-www-form-urlencoded; charset=utf-8",
        'X-CSRFToken': Cookies.get('csrftoken')
      }
    });
  },
  getJSON: function getJSON(originUrl, data, ifLoading, loadingText) {
    var div = document.createElement('div');
    if (ifLoading) {
      document.body.appendChild(div);
      ReactDOM.render(/*#__PURE__*/React.createElement("div", {
        style: {
          height: document.body.clientHeight,
          width: document.body.clientWidth,
          zIndex: 9999,
          backgroundColor: "rgba(0,0,0,0.15)",
          position: "fixed",
          left: 0,
          top: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: "absolute",
          top: 10,
          left: "45%",
          zIndex: 9999,
          width: 300
        }
      }, /*#__PURE__*/React.createElement(_Spin, {
        size: "large"
      }, /*#__PURE__*/React.createElement(_Alert, {
        message: /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: 16
          },
          className: "loading-text"
        }, loadingText || "Loading data"),
        showIcon: true
      })))), div); //加载进度
    }
    return this.get(originUrl, data).then(function (res) {
      ReactDOM.unmountComponentAtNode(div);
      if (res.redirected && !hasAlreadyAlert) {
        _Modal.error({
          title: "login timeout ",
          content: "Login timeout, will automatically return to the login interface after 3 seconds"
        });
        hasAlreadyAlert = true;
        setTimeout(function () {
          window.location.href = domain;
          hasAlreadyAlert = false;
        }, 3000);
      } else {
        return res.json();
      }
    })["catch"](function (err) {
      return {
        retcode: -1
      };
      console.log(err, "get"); /*Modal.error({
                               title: '系统异常',
                               content: '系统出现异常，将返回到登录页面进行重新登录操作，如果仍然存在异常，请联系管理员解决。',
                               onOk() {
                               ref = true;
                               window.location.href = domain;
                               },
                               });*/
    });
  },
  formPost: function formPost(url, data) {
    return fetch(weburl + url, {
      method: 'POST',
      headers: {
        /*'Accept': 'application/json',
        'Content-Type': 'application/json'*/
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      credentials: 'include',
      body: data
    }).then(function (res) {
      if (res.status === 500) {
        if (ref) {
          ref = false;
          _Modal.error({
            title: "System abnormality",
            content: "If there is an abnormality in the system, you will return to the login page for a new login operation. If there are still any abnormalities, please contact the administrator for resolution.",
            onOk: function onOk() {
              ref = true;
            }
          });
        }
      } else {
        return res.json();
      }
    })["catch"](function (error) {
      if (error === "TypeError: Failed to fetch") {
        if (ref) {
          ref = false;
          _Modal.error({
            title: "System abnormality",
            content: "If there is an abnormality in the system, you will return to the login page for a new login operation. If there are still any abnormalities, please contact the administrator for resolution.",
            onOk: function onOk() {
              ref = true;
              window.location.href = domain + "/index." + window.appLocale.locale + ".html";
            }
          });
        }
      }
    });
  },
  post: function post(url, data, mock, loadingText, ifLoading) {
    var fullUrl = weburl + url;
    var div = document.createElement('div');
    if (ifLoading) {
      document.body.appendChild(div);
      ReactDOM.render(/*#__PURE__*/React.createElement("div", {
        style: {
          height: document.body.clientHeight,
          width: document.body.clientWidth,
          zIndex: 9999,
          backgroundColor: "rgba(0,0,0,0.15)",
          position: "fixed",
          left: 0,
          top: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: "absolute",
          top: 10,
          left: "45%",
          zIndex: 9999,
          width: 350
        }
      }, /*#__PURE__*/React.createElement(_Spin, {
        size: "large"
      }, /*#__PURE__*/React.createElement(_Alert, {
        message: /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: 16
          },
          className: "loading-text"
        }, loadingText || "数据加载中"),
        showIcon: true
      })))), div); //加载进度
    }
    return fetch(fullUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      credentials: 'include',
      body: JSON.stringify(data)
    }).then(function (res) {
      ReactDOM.unmountComponentAtNode(div);
      if (res.redirected && !hasAlreadyAlert) {
        _Modal.error({
          title: '登录超时',
          content: '登录超时,3秒后将自动退回登录界面'
        });
        hasAlreadyAlert = true;
        setTimeout(function () {
          window.location.href = domain;
          hasAlreadyAlert = false;
        }, 3000);
      } else {
        return res.json();
      }
    })["catch"](function (err) {
      console.log(err, '33333'); /*Modal.error({
                                 title: '网络异常',
                                 content: '系统出现异常，将返回到登录页面进行重新登录操作，如果仍然存在异常，请联系管理员解决。',
                                 onOk() {
                                 ref = true;
                                 window.location.href = domain + "/index." + window.appLocale.locale + ".html";
                                 },
                                 });*/
    });
  },
  put: function put(url, data, mock, loadingText, ifLoading) {
    var fullUrl = weburl + url;
    var div = document.createElement('div');
    if (ifLoading) {
      document.body.appendChild(div);
      ReactDOM.render(/*#__PURE__*/React.createElement("div", {
        style: {
          height: document.body.clientHeight,
          width: document.body.clientWidth,
          zIndex: 9999,
          backgroundColor: "rgba(0,0,0,0.15)",
          position: "fixed",
          left: 0,
          top: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: "absolute",
          top: 10,
          left: "45%",
          zIndex: 9999,
          width: 350
        }
      }, /*#__PURE__*/React.createElement(_Spin, {
        size: "large"
      }, /*#__PURE__*/React.createElement(_Alert, {
        message: /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: 16
          },
          className: "loading-text"
        }, loadingText || "数据加载中"),
        showIcon: true
      })))), div); //加载进度
    }
    return fetch(fullUrl, {
      method: 'put',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      credentials: 'include',
      body: JSON.stringify(data)
    }).then(function (res) {
      ReactDOM.unmountComponentAtNode(div);
      if (res.redirected && !hasAlreadyAlert) {
        _Modal.error({
          title: '登录超时',
          content: '登录超时,3秒后将自动退回登录界面'
        });
        hasAlreadyAlert = true;
        setTimeout(function () {
          window.location.href = domain;
          hasAlreadyAlert = false;
        }, 3000);
      } else {
        return res.json();
      }
    })["catch"](function (err) {/*Modal.error({
                                title: '网络异常',
                                content: '系统出现异常，将返回到登录页面进行重新登录操作，如果仍然存在异常，请联系管理员解决。',
                                onOk() {
                                ref = true;
                                window.location.href = domain + "/index." + window.appLocale.locale + ".html";
                                },
                                });*/});
  },
  deleteJSON: function deleteJSON(originUrl, data, ifLoading, loadingText) {
    var div = document.createElement('div');
    if (ifLoading) {
      document.body.appendChild(div);
      ReactDOM.render(/*#__PURE__*/React.createElement("div", {
        style: {
          height: document.body.clientHeight,
          width: document.body.clientWidth,
          zIndex: 9999,
          backgroundColor: "rgba(0,0,0,0.15)",
          position: "fixed",
          left: 0,
          top: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: "absolute",
          top: 10,
          left: "45%",
          zIndex: 9999,
          width: 300
        }
      }, /*#__PURE__*/React.createElement(_Spin, {
        size: "large"
      }, /*#__PURE__*/React.createElement(_Alert, {
        message: /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: 16
          },
          className: "loading-text"
        }, loadingText || "Loading data"),
        showIcon: true
      })))), div); //加载进度
    }
    return this["delete"](originUrl, data).then(function (res) {
      ReactDOM.unmountComponentAtNode(div);
      if (res.redirected && !hasAlreadyAlert) {
        _Modal.error({
          title: "login timeout ",
          content: "Login timeout, will automatically return to the login interface after 3 seconds"
        });
        hasAlreadyAlert = true;
        setTimeout(function () {
          window.location.href = domain;
          hasAlreadyAlert = false;
        }, 3000);
      } else {
        return res.json();
      }
    })["catch"](function (err) {
      console.log(err); /*Modal.error({
                        title: '系统异常',
                        content: '系统出现异常，将返回到登录页面进行重新登录操作，如果仍然存在异常，请联系管理员解决。',
                        onOk() {
                        ref = true;
                        window.location.href = domain;
                        },
                        });*/
    });
  },
  deleteObj: function deleteObj(originUrl, data, ifLoading, loadingText) {
    var url = weburl + originUrl;
    var div = document.createElement('div');
    if (ifLoading) {
      document.body.appendChild(div);
      ReactDOM.render(/*#__PURE__*/React.createElement("div", {
        style: {
          height: document.body.clientHeight,
          width: document.body.clientWidth,
          zIndex: 9999,
          backgroundColor: "rgba(0,0,0,0.15)",
          position: "fixed",
          left: 0,
          top: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: "absolute",
          top: 10,
          left: "45%",
          zIndex: 9999,
          width: 300
        }
      }, /*#__PURE__*/React.createElement(_Spin, {
        size: "large"
      }, /*#__PURE__*/React.createElement(_Alert, {
        message: /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: 16
          },
          className: "loading-text"
        }, loadingText || "Loading data"),
        showIcon: true
      })))), div); //加载进度
    }
    return fetch(url, {
      method: 'delete',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'contentType': "application/x-www-form-urlencoded; charset=utf-8",
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      body: JSON.stringify(data)
    }).then(function (res) {
      ReactDOM.unmountComponentAtNode(div);
      if (res.redirected && !hasAlreadyAlert) {
        _Modal.error({
          title: "login timeout ",
          content: "Login timeout, will automatically return to the login interface after 3 seconds"
        });
        hasAlreadyAlert = true;
        setTimeout(function () {
          window.location.href = domain;
          hasAlreadyAlert = false;
        }, 3000);
      } else {
        return res.json();
      }
    })["catch"](function (err) {/*Modal.error({
                                title: '网络异常',
                                content: '系统出现异常，将返回到登录页面进行重新登录操作，如果仍然存在异常，请联系管理员解决。',
                                onOk() {
                                ref = true;
                                window.location.href = domain + "/index." + window.appLocale.locale + ".html";
                                },
                                });*/});
  }
};